import { regionAuth0Config, getApiRegion, DEFAULT_REGION } from "util/apiUtil"

export const getConfig = () => {
  const env = process.env.REACT_APP_ENV || "development"
  const region = getApiRegion() || DEFAULT_REGION
  const config = regionAuth0Config[env][region]

  return { ...config, leeway: 120 }
}
